import { useReport } from './hooks/use-context';

export function ImmediateProvidences() {
  const { body } = useReport();

  const { immediate_providences } = body;

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
    textAlign: 'left' as const,
  };

  const valueStyle = {
    textAlign: 'center' as const,
    backgroundColor: '#ffffcc',
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#d3d3d3',
          textAlign: 'center',
          padding: '4px',
          fontWeight: 'bold',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        PROVIDÊNCIA(S) IMEDIATA(S)
      </div>
      <div
        style={{
          ...cellStyle,
          ...valueStyle,
          padding: '8px',
          minHeight: '60px',
        }}
      >
        {immediate_providences?.answers?.[0]?.content || '-'}
      </div>
    </div>
  );
}
